const ART_W = 941;
const ART_H = 1672;

export const PASS5_SUPPORTS = Object.freeze([
  Object.freeze({ id: 'p5-upper-left', x: 276, y: 258, w: 168, h: 238, z: 3 }),
  Object.freeze({ id: 'p5-upper-right', x: 497, y: 258, w: 168, h: 238, z: 3 }),
  Object.freeze({ id: 'p5-mid-left', x: 270, y: 492, w: 155, h: 252, z: 4 }),
  Object.freeze({ id: 'p5-mid-right', x: 516, y: 492, w: 155, h: 252, z: 4 }),
  Object.freeze({ id: 'p5-lower-left', x: 286, y: 866, w: 148, h: 125, z: 5 }),
  Object.freeze({ id: 'p5-lower-right', x: 507, y: 866, w: 148, h: 125, z: 5 }),
]);

function pct(value, total) { return `${(value / total) * 100}%`; }

function createSupport(spec) {
  const node = document.createElement('div');
  node.className = 'bf-pass5-support';
  node.dataset.pass5Support = spec.id;
  node.setAttribute('aria-hidden', 'true');
  Object.assign(node.style, {
    left: pct(spec.x, ART_W),
    top: pct(spec.y, ART_H),
    width: pct(spec.w, ART_W),
    height: pct(spec.h, ART_H),
    zIndex: String(spec.z),
  });
  return node;
}

export function applyGameplayArtPass5(stage) {
  if (!stage || stage.dataset.parityPass5Applied === 'true') return;
  stage.dataset.parityPass5Applied = 'true';

  const shell = stage.querySelector('.bf-board-shell');
  if (!shell) return;

  ['support-left', 'support-right'].forEach((id) => {
    stage.querySelector(`[data-object-id="${id}"]`)?.classList.add('bf-pass5-replaced');
  });

  PASS5_SUPPORTS.forEach((spec) => shell.append(createSupport(spec)));
}
